module.exports = __webpack_public_path__ + "img/background.5d6d7cf0.webp";